import { VoiceSessionContext } from "@context/VoiceSessionContext";
import { useVoiceSession } from "@voice/use-voice-session";
import type { ReactNode } from "react";

/**
 * At the router root so navigation never closes the socket: there is
 * deliberately no reconnect, since resuming without the provider's turn state is
 * worse than ending the conversation.
 */
export const VoiceSessionProvider = ({ children }: { children: ReactNode }) => {
  const voice = useVoiceSession();

  return (
    <VoiceSessionContext.Provider value={voice}>
      {children}
    </VoiceSessionContext.Provider>
  );
};
